const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 4);

exports.countryDefinition = {
  country: 'Cyprus',
  code: 'CY',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(4)),
      error: 'Must be 4 characters, 1234'
    }
  ]
};
